import type { FraudSummary, RecordingStatus } from "../api/types";

/** Compact anti-fraud verdict chip: score + what settled it (a certain signal, the LLM, or
 * a human decision). Rendered on list cards and in the detail card header. */
export default function FraudChip({
  fraud,
  status,
}: {
  fraud: FraudSummary;
  status: RecordingStatus;
}) {
  const pct = Math.round(fraud.score * 100);
  let cls = "grey";
  let label = `Suspicious ${pct}%`;
  let title = "Anti-fraud signals were found but the verdict was not fraud";
  if (status === "fraud") {
    cls = "confirmed";
    label = "Fraud confirmed";
    title = "A reviewer confirmed this recording is fraudulent";
  } else if (fraud.cleared_at) {
    cls = "cleared";
    label = "Cleared by reviewer";
    title = "A reviewer judged this recording legitimate";
  } else if (fraud.verdict === "potential_fraud") {
    cls = "potential";
    label = `Potential fraud ${pct}%`;
    title = fraud.llm_called
      ? "Flagged by the vision model on top of deterministic signals"
      : "Flagged by a certain deterministic signal";
  }
  return (
    <span className={`fraud-chip ${cls}`} title={title}>
      {label}
    </span>
  );
}
